import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon } from 'lucide-react';
export function PainPoints() {
  const points = [{
    text: <>
          Lees nombres como "Mar Rojo" o "Monte Sinaí" y siguen siendo{' '}
          <strong data-id="element-248">palabras abstractas</strong> sin ninguna imagen real en tu
          mente.
        </>
  }, {
    text: <>
          Llevas <strong data-id="element-249">años estudiando la Biblia</strong> pero nunca has
          comprendido la <em data-id="element-250">geografía que moldeó cada acontecimiento</em>.
        </>
  }, {
    text: <>
          Quieres recursos visuales de calidad pero son{' '}
          <strong data-id="element-251">carísimos</strong>, <strong data-id="element-252">incompletos</strong> o simplemente{' '}
          <strong data-id="element-253">no existen en español</strong>.
        </>
  }, {
    text: <>
          Sientes que existe una{' '}
          <span className="underline decoration-red-400 decoration-2 underline-offset-2" data-id="element-254">
            "brecha"
          </span>{' '}
          entre lo que lees y lo que realmente entiendes porque te falta el{' '}
          <strong data-id="element-255">contexto visual</strong>.
        </>
  }, {
    text: <>
          No puedes pagar <strong data-id="element-256">$5,000</strong> en un viaje a Tierra Santa ni{' '}
          <strong data-id="element-257">$247</strong> en un curso de geografía bíblica para ver lo que
          lees.
        </>
  }];
  return <section className="py-12 bg-white" data-id="element-258">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        <FadeIn data-id="element-260">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-center text-navy-900 mb-7" data-id="element-261">
            Este Recurso Es Para Ti Si…
          </h2>
        </FadeIn>

        <div className="space-y-3" data-id="element-262">
          {points.map((point, index) => <FadeIn key={index} delay={index * 0.07} data-id="element-263">
              <div className="flex items-start gap-3 p-4 rounded-xl bg-red-50 border border-red-100" data-id="element-264">
                <XCircleIcon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-265" />
                <p className="text-base text-gray-800 leading-relaxed" data-id="element-266">
                  {point.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}